import React, { Component, useReducer } from 'react';
import { connect } from 'react-redux';
import { firestoreConnect, authIsReady } from 'react-redux-firebase';
import { compose } from 'redux';
import moment from 'moment';
import '../CSS/viewExpenses.css';
import {Modal} from 'react-bootstrap';  
import firebase from 'firebase';
import { Scrollbars } from 'react-custom-scrollbars';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';

//Displays the Transactions Modal
const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    backgroundColor: 'black'
  };
  return <div style={{ ...style, ...thumbStyle }} {...props} />;
};
//Using the custom scrollbars
const CustomScrollbars = props => (
  <Scrollbars
    renderThumbHorizontal={renderThumb}
    renderThumbVertical={renderThumb}
    {...props}
  />
);

class ViewExpensesModal extends Component
{
  constructor(props){
    super(props);
    }
    
  render()
  {
    const { addExpense } = this.props
    return(
      <Modal
      {...this.props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      className = "ModalView"
    >
      <Modal.Header className ="ModalHeaderView"></Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter" className = "ModalTitleView">
          View Transactions
        </Modal.Title>
      <Modal.Body className = "ModalBodyView">
        <p className = "p1">Date</p>
        <p  className = "p2">Description</p>
        <p  className = "p3">Category</p>
        <p  className = "p3">Amount</p>
      <CustomScrollbars>
      {/*Getting the values from the firebase collection and displaying it in a table*/}
        {/*Displaying the data based on the current user logged in */}
      {addExpense && addExpense.map(project => {
        console.log(firebase.auth().currentUser.email);
        return (
            <div className="container2" key={project.trans_id}>
            {project.user === firebase.auth().currentUser.email ?

                <table className="stripped">
                        <tr>
                           <td>{moment(project.date).format("DD-MM-YYYY")}</td>
                            <td >{project.description}</td>
                            <td>{project.category}</td>
                            <td>$ {project.amount}</td>
                        </tr>
                </table>
                :
                null
            }

            </div>
        )
    })}
    </CustomScrollbars>
      </Modal.Body>
      <Modal.Footer className = "ModalFooterView">
      <button  className = "ButtonCloseView" onClick={this.props.onHide}>Close</button>
      </Modal.Footer>
      </Modal>
    );
  }
}
  //Mapping the properties to firebase collection*
const mapStateToProps = (state) => {
  console.log(state);
  return {
      addExpense : state.firestore.ordered.addExpense
  }
}
//Connecting the collection and Modal, sorting transactions data
export default compose(
  connect(
      mapStateToProps),

  firestoreConnect([{ collection: 'addExpense' , orderBy : ['date' ]}])
)(ViewExpensesModal) 
